import { WrapPageElement } from './src/shared/WrapPageElement';
import { WrapRootElement } from './src/shared/WrapRootElement';
import 'swiper/css';

import '@assets/css/typography.css';
import '@assets/css/global.css';

export const wrapRootElement = WrapRootElement;
export const wrapPageElement = WrapPageElement;
